import { getDestinos } from "../services/categoriaService"
import {
    getPaqueteDiponiblesCategoriaAdmin,
    getPaqueteFechasDiponibles,
    putCambioFechaGrupal,
    putCambioFechaGrupalMasivoCustom
} from "../services/servicePaquete"
import {getListadoClaveViaje} from "../services/serviceViaje"

const dataInicial = {
    categoria: {},
    paquete: {},
    clavePaquete: "0",
    listaFechaSalida: [],
    listaPaquetes: [],
    listaCategoria: [],
    listaGrupoClaveViaje: [],
    exito: 0,
}

const GET_CAMBIO_CLAVE_VIAJE_CATEGORIA = "GET_CAMBIO_CLAVE_VIAJE_CATEGORIA"
const GET_CAMBIO_CLAVE_VIAJE_PAQUETES = "GET_CAMBIO_CLAVE_VIAJE_PAQUETES"
const GET_CAMBIO_CLAVE_VIAJE_FECHA_SALIDA = "GET_CAMBIO_CLAVE_VIAJE_FECHA_SALIDA"
const GET_CAMBIO_CLAVE_VIAJE_LISTA_CLAVE_VIAJE = "GET_CAMBIO_CLAGET_CAMBIO_CLAVE_VIAJE_LISTA_CLAVE_VIAJEVE_VIAJE_FECHA_SALIDA"
const PUT_CAMBIO_CLAVE_VIAJE_FECHA_SALIDA = "PUT_CAMBIO_CLAVE_VIAJE_FECHA_SALIDA"
const PUT_CAMBIO_CLAVE_VIAJE_FECHA_SALIDA_CUSTOM = "PUT_CAMBIO_CLAVE_VIAJE_FECHA_SALIDA_CUSTOM"
const ADD_CAMBIO_CALVE_VIAJE_CATEGORIA = "ADD_CAMBIO_CALVE_VIAJE_CATEGORIA"
const ADD_CAMBIO_CALVE_VIAJE_PAQUETE = "ADD_CAMBIO_CALVE_VIAJE_PAQUETE"

export default function cambiosClaveViajeReducer(state = dataInicial, action) {
    switch (action.type) {
        case PUT_CAMBIO_CLAVE_VIAJE_FECHA_SALIDA_CUSTOM:
            return { ...state, exito: action.exito }
        case PUT_CAMBIO_CLAVE_VIAJE_FECHA_SALIDA:
            return { ...state, exito: action.exito }
        case GET_CAMBIO_CLAVE_VIAJE_LISTA_CLAVE_VIAJE:
            return { ...state, listaGrupoClaveViaje: action.payload.listaGrupoClaveViaje }
        case ADD_CAMBIO_CALVE_VIAJE_PAQUETE:
            return { ...state, paquete: action.payload.paquete, clavePaquete: action.payload.clavePaquete }
        case ADD_CAMBIO_CALVE_VIAJE_CATEGORIA:
            return { ...state, categoria: action.payload.categoria }
        case GET_CAMBIO_CLAVE_VIAJE_FECHA_SALIDA:
            return { ...state, listaFechaSalida: action.payload.listaFechaSalida }
        case GET_CAMBIO_CLAVE_VIAJE_CATEGORIA:
            return { ...state, listaCategoria: action.payload.listaCategoria }
        case GET_CAMBIO_CLAVE_VIAJE_PAQUETES:
            return { ...state, listaPaquetes: action.payload.listaPaquetes }
        default:
            return state;
    }
}
export const addCategoriaAction = ({ categoria }) => (dispatch) => {
    dispatch({
        type: ADD_CAMBIO_CALVE_VIAJE_CATEGORIA,
        payload: {
            categoria
        }
    })
}
export const addPaqueteAction = ({ paquete }) => (dispatch) => {
    dispatch({
        type: ADD_CAMBIO_CALVE_VIAJE_PAQUETE,
        payload: {
            paquete,
            clavePaquete: paquete.ClavePaquete ?? "0"
        }
    })
}
export const obtenerCategoriasAction = () => async (dispatch) => {
    return await getDestinos().then(Response => {
        dispatch({
            type: GET_CAMBIO_CLAVE_VIAJE_CATEGORIA,
            payload: {
                listaCategoria: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerPaquetesAction = ({ IdCategoria }) => async (dispatch) => {
    return await getPaqueteDiponiblesCategoriaAdmin({ IdCategoria }).then(Response => {
        if (IdCategoria === 0) {
            dispatch({
                type: GET_CAMBIO_CLAVE_VIAJE_PAQUETES,
                payload: {
                    listaPaquetes: []
                }
            })
            return null
        }

        dispatch({
            type: GET_CAMBIO_CLAVE_VIAJE_PAQUETES,
            payload: {
                listaPaquetes: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerFechaSalidaAction = ({ ClavePaquete }) => async (dispatch) => {
    return await getPaqueteFechasDiponibles({ ClavePaquete }).then(Response => {
        dispatch({
            type: GET_CAMBIO_CLAVE_VIAJE_FECHA_SALIDA,
            payload: {
                listaFechaSalida: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}


export const obtenerGrupoClaveViajeAction = ({ ClavePaquete }) => async (dispatch) => {
    return await getListadoClaveViaje({ ClavePaquete }).then(Response => {
        dispatch({
            type: GET_CAMBIO_CLAVE_VIAJE_LISTA_CLAVE_VIAJE,
            payload: {
                listaGrupoClaveViaje: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const actulizarFechaSalidaAction = ({ ClaveViaje, IdBloqueSalida, IdObjeto }) => async (dispatch) => {
    return await putCambioFechaGrupal({ ClaveViaje, IdBloqueSalida, IdObjeto }).then(Response => {
        dispatch({
            type: PUT_CAMBIO_CLAVE_VIAJE_FECHA_SALIDA,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const actulizarFechaSalidaCustomAction = ({ ClaveViaje, FechaSalida }) => async (dispatch) => {
    return await putCambioFechaGrupalMasivoCustom({ ClaveViaje, FechaSalida }).then(Response => {
        dispatch({
            type: PUT_CAMBIO_CLAVE_VIAJE_FECHA_SALIDA_CUSTOM,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}